import React, { useEffect, useState } from 'react';
import { isAdmin, useContentSuggestions, useProfileCourses } from '../../../hooks';
import { CredentialSearchbar, IBLSpinLoader, UserCoursesBox } from '../../../components';
import './CourseViewContent.css';
import { NoItemView } from '../../../components/NoItemView';
import _ from 'lodash';
import { inIframe } from '../../../utils';
import { useTranslation } from 'react-i18next';
import { useDebounce } from '../../../hooks/useDebounce';
import CompletedCourses from './CompletedCourses';
import { useCompletedCourses } from '../../../hooks/useCompletedCourses';

export const CourseViewContent = ({ username }) => {
  const [coursesData, courseDataLoaded] = useProfileCourses(username);
  const {
    content, contentLoaded
  } = useContentSuggestions('course')
  const { completedData, completedDataLoaded } = useCompletedCourses();
  const { t } = useTranslation('library');
  const COURSE_TAB = "course"
  const ASSIGNMENT_TAB = "assignment"
  const COMPLETED_TAB = "completed"
  const [currentTab, setCurrentTab] = useState(COURSE_TAB)
  const [assignmentCourses, setAssignmentCourses] = useState<any[]>([])
  const [completedCourses, setCompletedCourses] = useState<any[]>([])
  const [courseSearchTerm, setCourseSearchTerm] = useState<string>('')
  const [assignedCourseSearchTerm, setAssignedCourseSearchTerm] = useState<string>('')
  const [completedCourseSearchTerm, setCompletedCourseSearchTerm] = useState<string>('')
  const [filteredCourses, setFilteredCourses] = useState<any[]>([])
  const [filteredAssignedCourses, setFilteredAssignedCourses] = useState<any[]>([])
  const [filteredCompletedCourses, setFilteredCompletedCourses] = useState<any[]>([])

  const tabs = [
    { key: COURSE_TAB, label: 'My courses' },
    { key: ASSIGNMENT_TAB, label: 'Assigned courses' },
    { key: COMPLETED_TAB, label: 'Completed courses' },
  ];

  useDebounce(() => {
    if (contentLoaded && content) {
      const _assignedCourses = content?.results?.map((course) => ({
        course
      })) ?? []
      setAssignmentCourses(_assignedCourses)
      setFilteredAssignedCourses(_assignedCourses)
    }
  }, 200, [contentLoaded, content]);

  useDebounce(() => {
    if (courseDataLoaded && Array.isArray(coursesData) && coursesData.length > 0) {
      setFilteredCourses(Array.isArray(coursesData) ? coursesData : [])
    }
  }, 200, [courseDataLoaded, coursesData]);

  useDebounce(() => {
    if (completedData && Array.isArray(completedData?.results) && completedData.results?.length > 0) {
      const courseObject = completedData.results?.[0] || {};
      const courseArray = Object.values(courseObject);
      const completedCourses = courseArray.filter((course: any) => {
        return course?.completed && (course?.completion_percentage == 100 || course?.completion_percentage == 100.0);
      });
      setFilteredCompletedCourses(Array.isArray(completedCourses) ? completedCourses : [])
      setCompletedCourses(Array.isArray(completedCourses) ? completedCourses : [])
    }
  }, 200, [completedDataLoaded, completedData]);

  useDebounce(() => {
    if (courseSearchTerm.length > 1) {
      setFilteredCourses(Array.isArray(coursesData) ? coursesData?.filter((course) => String(course?.course?.course_name).toUpperCase().includes(String(courseSearchTerm).toUpperCase())) : [])
    } else {
      setFilteredCourses(Array.isArray(coursesData) ? coursesData : [])
    }
  }, 200, [courseSearchTerm])

  useDebounce(() => {
    if (assignedCourseSearchTerm.length > 1) {
      setFilteredAssignedCourses(assignmentCourses.filter((course) => String(course?.course?.course_name).toUpperCase().includes(String(assignedCourseSearchTerm).toUpperCase())))
    } else {
      setFilteredAssignedCourses(assignmentCourses)
    }
  }, 200, [assignedCourseSearchTerm])

  useDebounce(() => {
    if (completedCourseSearchTerm.length > 1) {
      setFilteredCompletedCourses(completedCourses.filter((course) => String(course?.course_name).toUpperCase().includes(String(completedCourseSearchTerm).toUpperCase())))
    } else {
      setFilteredCompletedCourses(completedCourses)
    }
  }, 200, [completedCourseSearchTerm])

  const renderSearchBar = (
    searchTerm: string,
    setSearchTerm: (term: string) => void,
    title: string = '',
    recordCount: any = 0
  ) => (
    <CredentialSearchbar
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      title={title}
      recordCount={recordCount}
    />
  );


  return (
    <span>
      <div
        className="ov_panel active with-custom-tab"
        data-name="cs"
        style={{ marginTop: '20px' }}
      >
        <div className="br_cont" style={{ padding: '0px' }}>
          <div className="div-block-421" style={{ marginBottom: "20px" }}>
            <div className="profile_menu">
              {tabs.map(({ key, label }) => (
                <div
                  key={key}
                  onClick={() => setCurrentTab(key)}
                  className={`prof_menu first ${currentTab === key ? "active" : ""}`}
                >
                  {t(label)}
                </div>
              ))}
            </div>
          </div>
          {
            currentTab === COURSE_TAB ? (
              courseDataLoaded ? (
                _.isEmpty(coursesData) && inIframe() ? (
                  <NoItemView
                    displayMessage={
                      inIframe()
                        ? `${username} ${t(
                          "doesn't have any courses in progress yet."
                        )}`
                        : t("You don't have any courses in progress yet.")
                    }
                    displayPadding={true}
                  />
                ) : (
                  <div className="br_row">
                    {renderSearchBar(
                      courseSearchTerm,
                      setCourseSearchTerm,
                      t('Courses'),
                      Array.isArray(filteredCourses) ? filteredCourses.length : 0
                    )}
                    <div className="div-block-430 sl course_grid">
                      <UserCoursesBox
                        userCourses={filteredCourses}
                        userCoursesLoaded={courseDataLoaded}
                        username={username}
                      />
                    </div>
                  </div>
                )
              ) : (
                <IBLSpinLoader size={40} containerHeight={'200px'} />
              )
            ) : currentTab === ASSIGNMENT_TAB ? (
              contentLoaded ? (
                _.isEmpty(assignmentCourses) && inIframe() ? (
                  <NoItemView
                    displayMessage={
                      inIframe()
                        ? `${username} ${t(
                          "hasn't been assigned to a courses yet."
                        )}`
                        : t("You haven't been assigned to a course yet.")
                    }
                    displayPadding={true}
                  />
                ) : (
                  <div className="br_row">
                    {renderSearchBar(assignedCourseSearchTerm, setAssignedCourseSearchTerm, t('Assigned Courses'), Array.isArray(filteredAssignedCourses) ? filteredAssignedCourses.length : 0)}
                    <div className="div-block-430 sl course_grid">
                      <UserCoursesBox
                        userCourses={filteredAssignedCourses}
                        userCoursesLoaded={contentLoaded}
                        username={username}
                        showDiscoverBlock={false}
                      />
                    </div>
                    {
                      filteredAssignedCourses.length <= 0 &&
                      <NoItemView
                        displayMessage={
                          inIframe()
                            ? `${username} ${t(
                              "hasn't been assigned to a courses yet."
                            )}`
                            : t("You haven't been assigned to a course yet.")
                        }
                        displayPadding={true}
                      />
                    }
                  </div>
                )
              ) : (
                <IBLSpinLoader size={40} containerHeight={'200px'} />
              )
            ) : (
              completedDataLoaded ? (
                _.isEmpty(completedCourses) ? (
                  <div className="br_row">
                  {renderSearchBar(completedCourseSearchTerm, setCompletedCourseSearchTerm, t('Completed Courses'), Array.isArray(filteredCompletedCourses) ? filteredCompletedCourses.length : 0)}
                  <NoItemView
                    displayMessage={
                      inIframe()
                        ? `${username} ${t(
                          "hasn't completed any courses yet."
                        )}`
                        : t("You haven't completed any course yet.")
                    }
                    displayPadding={true}
                  />
                  </div>
                )
                  : (
                    <div className="br_row">
                      {renderSearchBar(completedCourseSearchTerm, setCompletedCourseSearchTerm, t('Completed Courses'), Array.isArray(filteredCompletedCourses) ? filteredCompletedCourses.length : 0)}
                      <div className="div-block-430 sl course_grid">
                        <CompletedCourses completedCourses={filteredCompletedCourses} />
                      </div>
                    </div>
                  )

              ) : (
                <IBLSpinLoader size={40} containerHeight={'200px'} />
              )
            )
          }
        </div>
      </div>
    </span>
  );
};
